import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AddComponent } from "./add/add.component";
import { OpenSpaceService } from "src/app/services/open-space.service";
import { OpenSpace } from "src/app/entities/openSpace";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { StorageMap } from "@ngx-pwa/local-storage";
import { AuthService } from "src/app/services/auth.service";
import { Router } from "@angular/router";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";
import { ToastrService } from "ngx-toastr";
import { formatDate } from '@angular/common';

@Component({
  selector: "app-openspace",
  templateUrl: "./openspace.component.html",
  styleUrls: ["./openspace.component.css"],
})
export class OpenspaceComponent implements OnInit {
  constructor(
    private storage: StorageMap,
    private dialog: MatDialog,
    private openService: OpenSpaceService,
    private authServ: AuthService,
    private router: Router,
    private confirmationDialog: MatDialog,
    private toastr: ToastrService
  ) {}

  displayedColumns: string[] = [
    "name",
    "showVotes",
    "showProposer",
    "eventDate",
    "maxVotes",
    "actions",
  ];
  displayedColumnsEnded: string[] = [
    "name",
    "showVotes",
    "showProposer",
    "eventDate",
    "maxVotes",
    "actions",
  ];
  openSpaceId: number;
  name: string;
  openContent: any;
  openAllContent: any;
  activeOpenSpaces = new MatTableDataSource<OpenSpace>();
  inactiveOpenSpaces = new MatTableDataSource<OpenSpace>();
  @ViewChild("hBSort") hBSort: MatSort;
  @ViewChild("sBSort") sBSort: MatSort;
  noInactiveOpens = false;
  noActiveOpens = false;
  isAdmin = false;

  ngOnInit(): void {
    this.loadcontent();
  }

  addOpen() {
    const dialogRef = this.dialog.open(AddComponent, {
      data: { editMode: false, viewMode: false },
    });
    dialogRef.afterClosed().subscribe((_) => this.loadcontent());
  }

  selectOpenSpaceName(openId: number) {
    this.storage.set("selectedOpenId", openId.toString()).subscribe({
      next: () => {
        this.router.navigate(["/dashboard/" + openId]);
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  loadcontent() {
    this.isAdmin = this.authServ.isAdminAccount();
    if (this.isAdmin) {
      this.getActiveOpenList();
      this.getInactiveOpenList();
    } else {
      this.getInactiveOpenList();
      //this.router.navigate(["/dashboard"]);
    }
  }

  getActiveOpenList() {
    this.openService.getActiveOpenSpaces().subscribe(
      (data) => {
        this.openContent = data;
        this.activeOpenSpaces = new MatTableDataSource(
          this.openContent.OpenSpaces
        );
        this.activeOpenSpaces.sort = this.hBSort;
        if (this.activeOpenSpaces?.data?.length === 0) {
          this.noActiveOpens = true;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  editOpen(openSpace: OpenSpace) {
    const dialogRef = this.dialog.open(AddComponent, {
      data: { openSpace, editMode: true },
    });
    dialogRef.afterClosed().subscribe((_) => this.loadcontent());
  }

  viewOpen(openSpace: OpenSpace) {
    const dialogRef = this.dialog.open(AddComponent, {
      data: { openSpace, viewMode: true },
    });
    dialogRef.afterClosed().subscribe((_) => this.loadcontent());
  }

  downloadOpen(openSpace: OpenSpace) {
    this.confirmationDialog
      .open(ConfirmationDialogComponent, {
        data: "¿Desea generar y descargar el Reporte del Open Space?",
      })
      .afterClosed()
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.openService.getReportOpen(openSpace.id).subscribe(
            (data) => {
              this.toastr.success("Reporte Generado");
              let result = "" + data;
              this.downloadFile(result, openSpace.name);
            },
            (error) => {
              console.error(error);
            }
          );
        }
      });
  }

  downloadFile(csvData: string, openName: string) {
    const blob = new Blob(["\ufeff" + csvData], {
      type: "text/csv;charset=utf-8;",
    });
    let dwldLink = document.createElement("a");
    const url = window.URL.createObjectURL(blob);

    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", 'Report_' + openName.replace(' ', '') + '_' + formatDate(Date.now(), 'dd-MM-yyyy', 'en-US') + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  getInactiveOpenList() {
    this.openService.getInactiveOpenSpaces().subscribe(
      (data) => {
        this.openAllContent = data;
        this.inactiveOpenSpaces = new MatTableDataSource(
          this.openAllContent.OpenSpaces
        );
        this.inactiveOpenSpaces.sort = this.sBSort;
        if (this.inactiveOpenSpaces.data.length === 0) {
          this.noInactiveOpens = true;
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  doFilter = (filterValue: string) => {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.activeOpenSpaces.filter = filterValue;
    this.inactiveOpenSpaces.filter = filterValue;

    this.activeOpenSpaces.filterPredicate = function (
      data,
      filter: string
    ): boolean {
      return data.name.toLowerCase().includes(filter);
    };
  };
}
